module.exports = __webpack_public_path__ + "img/IMG_7703.8fc45bb1.jpg";